/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-section-connection';
const prefix = `${moduleName}.${componentName}`;

export const packetsLabel = `${prefix}.packetsLabel`;
export const transfersLabel = `${prefix}.transfersLabel`;
export const connectionIssuesLabel = `${prefix}.connectionIssuesLabel`;

export const ENGLISH = {
    [packetsLabel]: 'Packets',
    [transfersLabel]: 'Transfers',
    [connectionIssuesLabel]: 'Connection Issues',
};
